import { FieldTypeEnum } from '../Enums/FieldEnum';
import { SignUpField,
    NewsItemField,
    CompanyField,
    CompanyAddressField,
    CompanyUserField,
    BuyLicensePackageField,
    BuyLicenseField,
    LicenseDetailsBuyField,
    CheckoutField,
    AdminUserField,
    AdminUserAddressField,
    AdminUserProfileField,
    RolesField,
    ModuleSettingField,
    GenerateLicenseField,
    BillingDetailsField,
    InvoiceField,
    DetailsInvoiceField,
    BillingAddressField,
    BillingLicenseDetailsField,
    CheckoutDataField,
    PasswordForgotField,
    VendorField,
    RegistrationCodeField,
} from '../Enums/ParametersEnum';

const RequiredParametersHelper = {
    authentication: function () {
        return [
            {
                keyName: 'username',
                labelName: "Username",
                type: FieldTypeEnum.STRING,
            },
            {
                keyName: 'password',
                labelName: "Password",
                type: FieldTypeEnum.STRING,
            },
        ];
    },
    signup: function () {
        let signUpRequiredFields: any = [
            {
                keyName: SignUpField.REGISTRATION_CODE,
                labelName: "Registration Code",
                type: FieldTypeEnum.STRING,
            },
            {
                keyName: SignUpField.ACCOUNT_TYPE,
                labelName: "Account Type",
                type: FieldTypeEnum.STRING,
            },
            {
                keyName: SignUpField.PROFILE,
                labelName: "Profile",
                type: FieldTypeEnum.OBJECT,
                fields: [
                    {
                        keyName: AdminUserProfileField.NAME,
                        labelName: "POC Name",
                        type: FieldTypeEnum.STRING,
                    },
                    {
                        keyName: AdminUserProfileField.TAX_NO,
                        labelName: "Tax Number",
                        type: FieldTypeEnum.STRING,
                    },
                    {
                        keyName: AdminUserProfileField.COMPANY_PUBLIC_ID,
                        labelName: "Company",
                        type: FieldTypeEnum.STRING,
                    },
                    
                    {
                        keyName: AdminUserProfileField.CURRENCY_CODE,
                        labelName: "Locale",
                        type: FieldTypeEnum.STRING,
                    },
                ],
            },
            {
                keyName: SignUpField.USERNAME,
                labelName: "Username",
                type: FieldTypeEnum.STRING,
            },
            {
                keyName: SignUpField.PASSWORD,
                labelName: "Password",
                type: FieldTypeEnum.STRING,
            },
            {
                keyName: SignUpField.USER_EMAIL,
                labelName: "User Email",
                type: FieldTypeEnum.EMAIL,
            },
            {
                keyName: SignUpField.USER_CONTACT_NUMBER,
                labelName: "User Contact Number",
                type: FieldTypeEnum.NUMBER,
            },
            {
                keyName: SignUpField.RECAPTCHA_KEY,
                labelName: "reCAPTCHA",
                type: FieldTypeEnum.STRING,
            },
        ];

        return signUpRequiredFields;
    },
    forgotPassword: function () {
        let signUpRequiredFields: any = [
            {
                keyName: PasswordForgotField.USER_EMAIL,
                labelName: "User Email",
                type: FieldTypeEnum.EMAIL,
            },
        ];

        return signUpRequiredFields;
    },
    news: function () {
        return [
            {
                keyName: NewsItemField.NAME,
                labelName: "Subject",
                type: FieldTypeEnum.STRING,
            },
            {
                keyName: NewsItemField.DATE,
                labelName: "Date",
                type: FieldTypeEnum.DATETIME,
            },
        ];
    },
    company: function () {
        return [
            {
                keyName: CompanyField.NAME,
                labelName: "Company Name",
                type: FieldTypeEnum.STRING,
            },
            {
                keyName: CompanyField.CONTACT_PERSON,
                labelName: "Contact Person",
                type: FieldTypeEnum.STRING,
            },
            {
                keyName: CompanyField.CONTACT_PHONE,
                labelName: "Phone Number",
                type: FieldTypeEnum.STRING,
            },
            {
                keyName: CompanyField.EMAIL,
                labelName: "Email Address",
                type: FieldTypeEnum.EMAIL,
            },
            {
                keyName: CompanyField.DATABASE,
                labelName: "Database",
                type: FieldTypeEnum.STRING,
            },
            // {
            //     keyName: CompanyField.REGISTRATION_CODE,
            //     labelName: "Registration Code",
            //     type: FieldTypeEnum.STRING,
            // },
            {
                keyName: CompanyField.VENDOR_PUBLIC_ID,
                labelName: "Vendor",
                type: FieldTypeEnum.STRING,
            },
            {
                keyName: CompanyField.ADDRESS,
                labelName: "Address",
                type: FieldTypeEnum.OBJECT,
                fields: [
                    {
                        keyName: CompanyAddressField.STREET_ADDRESS,
                        labelName: "Billing Address",
                        type: FieldTypeEnum.STRING,
                    },
                ],
            },
        ];
    },
    companyUser: function () {
        return [
            {
                keyName: CompanyUserField.FIRST_NAME,
                labelName: "First Name",
                type: FieldTypeEnum.STRING,
            },
            {
                keyName: CompanyUserField.LAST_NAME,
                labelName: "Last Name",
                type: FieldTypeEnum.STRING,
            },
            {
                keyName: CompanyUserField.EMPLOYEE_CODE,
                labelName: "Employee Code",
                type: FieldTypeEnum.STRING,
            },
            {
                keyName: CompanyUserField.USERNAME,
                labelName: "Username",
                type: FieldTypeEnum.STRING,
            },
            {
                keyName: CompanyUserField.DATABASE_ID,
                labelName: "Database Id",
                type: FieldTypeEnum.STRING,
            },
        ];
    },
    buyLicensePackage: function () {
        return [
            {
                keyName: BuyLicensePackageField.LICENSE_TYPE,
                labelName: "License Type",
                type: FieldTypeEnum.NUMBER,
            },
            {
                keyName: BuyLicensePackageField.LICENSE_PACKAGE,
                labelName: "License Package",
                type: FieldTypeEnum.NUMBER,
            },
            {
                keyName: BuyLicensePackageField.VALIDITY_IN_YRS,
                labelName: "Validity",
                type: FieldTypeEnum.NUMBER,
            },
            {
                keyName: BuyLicensePackageField.ISSUE_DATE,
                labelName: "License Issue Date",
                type: FieldTypeEnum.DATETIME,
            },
            {
                keyName: BuyLicensePackageField.EXPIRY_DATE,
                labelName: "License Expiry Date",
                type: FieldTypeEnum.STRING,
            },
            {
                keyName: BuyLicensePackageField.COMPANY_PUBLIC_ID,
                labelName: "Issued Company",
                type: FieldTypeEnum.STRING,
            },
        ];
    },
    buyLicense: function () {
        return [
            {
                keyName: BuyLicenseField.LICENSE_DETAILS,
                labelName: "License",
                type: FieldTypeEnum.OBJECT,
                fields: [
                    {
                        keyName: LicenseDetailsBuyField.LICENSE_TYPE,
                        labelName: "License Type",
                        type: FieldTypeEnum.NUMBER,
                    },
                    {
                        keyName: LicenseDetailsBuyField.MODULES,
                        labelName: "Module",
                        type: FieldTypeEnum.ARRAY,
                    },
                    {
                        keyName: LicenseDetailsBuyField.STORAGE_CAPACITY,
                        labelName: "Data Storage",
                        type: FieldTypeEnum.NUMBER,
                    },
                    {
                        keyName: LicenseDetailsBuyField.USER_CAPACITY,
                        labelName: "No. Of Users",
                        type: FieldTypeEnum.NUMBER,
                    },
                    {
                        keyName: LicenseDetailsBuyField.VALIDITY,
                        labelName: "Validity",
                        type: FieldTypeEnum.NUMBER,
                    },
                    {
                        keyName: LicenseDetailsBuyField.VALIDITY_TYPE,
                        labelName: "Validity Type",
                        type: FieldTypeEnum.NUMBER,
                    },
                    {
                        keyName: LicenseDetailsBuyField.ISSUE_DATE,
                        labelName: "License Issue Date",
                        type: FieldTypeEnum.DATETIME,
                    },
                    {
                        keyName: LicenseDetailsBuyField.EXPIRY_DATE,
                        labelName: "License Expiry Date",
                        type: FieldTypeEnum.STRING,
                    },
                    {
                        keyName: LicenseDetailsBuyField.COMPANY_PUBLIC_ID,
                        labelName: "Issued Company",
                        type: FieldTypeEnum.STRING,
                    },
                ],
            },        
        ];
    },
    generateLicense: function () {
        return [
            {
                keyName: GenerateLicenseField.LICENSE_TYPE,
                labelName: "License Type",
                type: FieldTypeEnum.NUMBER,
            },
            {
                keyName: GenerateLicenseField.MODULES,
                labelName: "Module",
                type: FieldTypeEnum.ARRAY,
            },
            {
                keyName: GenerateLicenseField.USER_CAPACITY,
                labelName: "No. Of Users",
                type: FieldTypeEnum.NUMBER,
            },
            {
                keyName: GenerateLicenseField.STORAGE_CAPACITY,
                labelName: "Data Storage",
                type: FieldTypeEnum.NUMBER,
            },
            {
                keyName: GenerateLicenseField.VALIDITY,
                labelName: "Validity",
                type: FieldTypeEnum.NUMBER,
            },
            {
                keyName: GenerateLicenseField.VALIDITY_TYPE,
                labelName: "Validity Type",
                type: FieldTypeEnum.NUMBER,
            },
            {
                keyName: GenerateLicenseField.ISSUE_DATE,
                labelName: "License Issue Date",
                type: FieldTypeEnum.DATETIME,
            },
            {
                keyName: GenerateLicenseField.EXPIRY_DATE,
                labelName: "License Expiry Date",
                type: FieldTypeEnum.STRING,
            },
        ];
    },
    checkoutBillingInfo: function () {
        return [
            {
                keyName: CheckoutDataField.BILLING_DETAILS,
                labelName: "Billing Details",
                type: FieldTypeEnum.OBJECT,
                fields: [
                    {
                        keyName: BillingDetailsField.CONTACT_PERSON,
                        labelName: "Name",
                        type: FieldTypeEnum.STRING,
                    },
                    {
                        keyName: BillingDetailsField.CONTACT_PHONE,
                        labelName: "Contact Number",
                        type: FieldTypeEnum.STRING,
                    },
                    {
                        keyName: BillingDetailsField.EMAIL,
                        labelName: "Email",
                        type: FieldTypeEnum.EMAIL,
                    },
                    {
                        keyName: BillingDetailsField.ADDRESS,
                        labelName: "Address",
                        type: FieldTypeEnum.OBJECT,
                        fields: [
                            {
                                keyName: BillingAddressField.STREET_ADDRESS,
                                labelName: "Billing Address",
                                type: FieldTypeEnum.STRING,
                            },
                        ],
                    },
                ],
            },     
        ];
    },
    checkoutPaymentInfoFPX: function () {
        return [
            {
                keyName: CheckoutField.PAYMENT_TYPE,
                labelName: "Payment Type",
                type: FieldTypeEnum.NUMBER,
            },
            {
                keyName: CheckoutField.BANK,
                labelName: "Bank",
                type: FieldTypeEnum.STRING,
            },
        ];
    },
    checkoutPaymentInfoCreditDebitCard: function () {
        return [
            {
                keyName: CheckoutField.PAYMENT_TYPE,
                labelName: "Payment Type",
                type: FieldTypeEnum.NUMBER,
            },
            {
                keyName: CheckoutField.CARD_ACCOUNT_NAME,
                labelName: "Name on card",
                type: FieldTypeEnum.STRING,
            },
            {
                keyName: CheckoutField.CARD_NUMBER,
                labelName: "Credit card number",
                type: FieldTypeEnum.STRING,
            },
            {
                keyName: CheckoutField.CARD_EXPIRATION,
                labelName: "Expiration",
                type: FieldTypeEnum.DATETIME,
            },
            {
                keyName: CheckoutField.CVV,
                labelName: "CVV",
                type: FieldTypeEnum.STRING,
            },
        ];
    },
    checkoutPaymentInfoEWallet: function () {
        return [
            {
                keyName: CheckoutField.PAYMENT_TYPE,
                labelName: "Payment Type",
                type: FieldTypeEnum.NUMBER,
            },
            {
                keyName: CheckoutField.E_WALLET,
                labelName: "e-Wallet",
                type: FieldTypeEnum.STRING,
            },
        ];
    },
    adminUserControl: function () {
        //Need to set the object array as parameter first before returning it to set a datatype that causes crash, this is due to deep object array within object array
        let adminUserRequiredFields: any = [
            {
                keyName: AdminUserField.PROFILE,
                labelName: "Profile",
                type: FieldTypeEnum.OBJECT,
                fields: [
                    {
                        keyName: AdminUserProfileField.NAME,
                        labelName: "POC Name",
                        type: FieldTypeEnum.STRING,
                    },
                    {
                        keyName: AdminUserProfileField.CONTACT_NUMBER,
                        labelName: "Contact Number",
                        type: FieldTypeEnum.NUMBER,
                    },
                    {
                        keyName: AdminUserProfileField.EMAIL,
                        labelName: "Email",
                        type: FieldTypeEnum.EMAIL,
                    },
                    {
                        keyName: AdminUserProfileField.COMPANY_PUBLIC_ID,
                        labelName: "Registered Company",
                        type: FieldTypeEnum.STRING,
                    },
                    {
                        keyName: AdminUserProfileField.TAX_NO,
                        labelName: "Tax Number",
                        type: FieldTypeEnum.STRING,
                    },
                    {
                        keyName: AdminUserProfileField.CURRENCY_CODE,
                        labelName: "Locale",
                        type: FieldTypeEnum.STRING,
                    },
                ],
            },
            {
                keyName: AdminUserField.ADDRESS,
                labelName: "Address",
                type: FieldTypeEnum.OBJECT,
                fields: [
                    {
                        keyName: AdminUserAddressField.STREET_ADDRESS,
                        labelName: "Billing Address",
                        type: FieldTypeEnum.STRING,
                    },
                ],
            },
            {
                keyName: AdminUserField.ROLE_PUBLIC_ID,
                labelName: "Role",
                type: FieldTypeEnum.STRING,
            },
            {
                keyName: AdminUserField.USERNAME,
                labelName: "Username",
                type: FieldTypeEnum.STRING,
            },
            {
                keyName: AdminUserField.PASSWORD,
                labelName: "New Password",
                type: FieldTypeEnum.STRING,
            },
            {
                keyName: AdminUserField.CONFIRM_PASSWORD,
                labelName: "Confirm Password",
                type: FieldTypeEnum.STRING,
            },
            {
                keyName: AdminUserField.USER_EMAIL,
                labelName: "User Email",
                type: FieldTypeEnum.EMAIL,
            },
            {
                keyName: AdminUserField.USER_CONTACT_NUMBER,
                labelName: "User Contact Number",
                type: FieldTypeEnum.NUMBER,
            },
            {
                keyName: AdminUserField.STATUS,
                labelName: "Status",
                type: FieldTypeEnum.STRING,
            },
        ];

        return adminUserRequiredFields;
    },
    resetPassword: function () {
        return [
            {
                keyName: AdminUserField.PASSWORD,
                labelName: "New Password",
                type: FieldTypeEnum.STRING,
            },
            {
                keyName: AdminUserField.CONFIRM_PASSWORD,
                labelName: "Confirm Password",
                type: FieldTypeEnum.STRING,
            },
        ];
    },
    roles: function () {
        return [
            {
                keyName: RolesField.NAME,
                labelName: "Name",
                type: FieldTypeEnum.STRING,
            },
            {
                keyName: RolesField.DESCRIPTION,
                labelName: "Description",
                type: FieldTypeEnum.STRING,
            },
            {
                keyName: RolesField.TYPE,
                labelName: "Role Type",
                type: FieldTypeEnum.NUMBER,
            },
        ];
    },
    moduleSettings: function () {
        return [
            {
                keyName: ModuleSettingField.NAME,
                labelName: "Name",
                type: FieldTypeEnum.STRING,
            },
            {
                keyName: ModuleSettingField.DESCRIPTION,
                labelName: "Description",
                type: FieldTypeEnum.STRING,
            },
        ];
    },
    billings: function () {
        let billingRequiredFields: any = [
            {
                keyName: BillingDetailsField.COMPANY_PUBLIC_ID,
                labelName: "Issued Company",
                type: FieldTypeEnum.STRING,
            },
            {
                keyName: DetailsInvoiceField.BILLING_DETAILS,
                labelName: "Billing Details",
                type: FieldTypeEnum.OBJECT,
                fields: [
                    {
                        keyName: BillingDetailsField.ADDRESS,
                        labelName: "Address",
                        type: FieldTypeEnum.OBJECT,
                        fields: [
                            {
                                keyName: BillingAddressField.FULL_ADDRESS,
                                labelName: "Address",
                                type: FieldTypeEnum.STRING,
                            },
                        ],
                    },
                    {
                        keyName: BillingDetailsField.CONTACT_PHONE,
                        labelName: "Contact Person",
                        type: FieldTypeEnum.STRING,
                    },
                    {
                        keyName: BillingDetailsField.CONTACT_PERSON,
                        labelName: "Contact Person",
                        type: FieldTypeEnum.STRING,
                    }
                ], 
            },
            {
                keyName: DetailsInvoiceField.LICENSE_DETAILS,
                labelName: "License Details",
                type: FieldTypeEnum.OBJECT,
                fields: [
                    {
                        keyName: BillingLicenseDetailsField.LICENSE_TYPE,
                        labelName: "License Type",
                        type: FieldTypeEnum.NUMBER,
                    },
                    {
                        keyName: BillingLicenseDetailsField.USER_CAPACITY,
                        labelName: "No. of Users",
                        type: FieldTypeEnum.NUMBER,
                    },
                    {
                        keyName: BillingLicenseDetailsField.MODULES,
                        labelName: "Module",
                        type: FieldTypeEnum.ARRAY,
                    },
                    {
                        keyName: BillingLicenseDetailsField.STORAGE_CAPACITY,
                        labelName: "Data Storage",
                        type: FieldTypeEnum.NUMBER,
                    },
                    {
                        keyName: BillingLicenseDetailsField.VALIDITY,
                        labelName: "Validity",
                        type: FieldTypeEnum.NUMBER,
                    },
                    {
                        keyName: BillingLicenseDetailsField.VALIDITY_TYPE,
                        labelName: "Validity Type",
                        type: FieldTypeEnum.NUMBER,
                    },
                    {
                        keyName: BillingLicenseDetailsField.ISSUE_DATE,
                        labelName: "License Issue Date",
                        type: FieldTypeEnum.DATETIME,
                    },
                    {
                        keyName: BillingLicenseDetailsField.EXPIRY_DATE,
                        labelName: "License Expiry Date",
                        type: FieldTypeEnum.STRING,
                    },
                ], 
            }
        ];

        return billingRequiredFields;
    },
    vendors: function () {
        return [
            {
                keyName: VendorField.CODE,
                labelName: "Code",
                type: FieldTypeEnum.STRING,
            },
            {
                keyName: VendorField.NAME,
                labelName: "Name",
                type: FieldTypeEnum.STRING,
            },
        ];
    },
    registrationCodes: function () {
        return [
            {
                keyName: RegistrationCodeField.CODE,
                labelName: "Registration Code",
                type: FieldTypeEnum.STRING,
            },
            {
                keyName: RegistrationCodeField.USER_TYPE,
                labelName: "Type",
                type: FieldTypeEnum.NUMBER,
            },
        ];
    },
    authenticationCode: function () {
        return [
            {
                keyName: "code",
                labelName: "Authentication Code",
                type: FieldTypeEnum.STRING,
            },
        ];
    },
    otpCode: function () {
        return [
            {
                keyName: "code",
                labelName: "OTP",
                type: FieldTypeEnum.STRING,
            },
        ];
    },
    recoverAccountEmail: function () {
        return [
            {
                keyName: "userEmail",
                labelName: "Email Address",
                type: FieldTypeEnum.EMAIL,
            },
        ];
    },
    verifyRecoverAccountEmail: function () {
        return [
            // {
            //     keyName: "userEmail",
            //     labelName: "Email Address",
            //     type: FieldTypeEnum.EMAIL,
            // },
            {
                keyName: "code",
                labelName: "Recovery Code",
                type: FieldTypeEnum.STRING,
            },
        ];
    },
}
export default RequiredParametersHelper;